"use strict";
export default {
	toneNames : [" ","Цель. Объединение. Привлечение.", "Принятие вызова. Поляризация. Стабилизация", "Служение. Активация. Связь", "Форма. Определение. Соизмерение", "Сияние. Наделение силой. Управление", "Равенство. Органицизация. Уравновешивание","Сонастройка. Проведение. Вдохновение", "Целостность. Гармонизация. Моделирование", "Намерение. Пульсация. Осуществление", "Проявленность. Совершенствование. Создание", "Освобождение. Растворение. Отпускание", "Сотрудничество. Посвящение. Универсализация", "Присутствие. Стойкость. Трасцендентность"],
	daysignLettersUpper : ["", "Б", "В", "Г", "Д", "Ф", "Ж", "Р", "Л", "М", "Н", "П", "К", "С", "З", "Т", "Х", "Ц", "Ч", "Ш", "Щ"],
	daysignLettersLower : ["", "б", "в", "г", "д", "ф", "ж", "р", "л", "м", "н", "п", "к", "с", "з", "т", "х", "ц", "ч", "ш", "щ"],
	julian : function(y,m,d) {
		m = parseInt(m); y = parseInt(y); d = parseInt(d);
		if (m < 3) { m += 12; y -= 1; }
		var a = Math.floor(y / 100);
		var b = 2 - a + Math.floor( a / 4);
		var j = Math.floor(365.25 * (y+4716.0)) + Math.floor(30.6001 * (m+1)) + d + b -1524;
		return j;
	},
	toneFromKin : function (kin) {
		return (kin%13)?(kin%13):13;
	},
	mayaIso : function(isoDate) {
		
		var n = isoDate.split('-');
		var date = new Date(n[0],n[1]-1,n[2]);
		return this.maya(date);
	},
	maya : function(date) {
		var corr = 584283; // Thompson Goodman Martinez Offset 
		var y = date.getFullYear();
		var m = date.getMonth()+1;
		var d = date.getDate();
		
		var days = this.julian(y, m, d) - corr;
		var kin = days - (260 * (Math.floor(days / 260))) - 100;
		if (kin < 1) kin += 260;
		var nl = days - (9 * (Math.floor((days - 1) / 9)));
		
		// Calculate Long Count;
		var baktun = Math.floor(days / 144000);
		days -= baktun * 144000;
		var katun = Math.floor(days / 7200);
		days -= katun * 7200;
		var tun = Math.floor(days / 360);
		days -= tun * 360;
		var uinal = Math.floor(days / 20);
		var day = kin % 20;
		var tone = (kin % 13) ? (kin % 13) : 13;
		var daysign = (kin % 20) ? (kin % 20) : 20;
		var trecena = ((daysign - tone + 1) < 1) ? (daysign - tone + 21) : (daysign - tone + 1);
		return {
			date: date,
			kin : kin,
			fantoms: this.getFantoms(daysign, trecena),
			trecena : trecena,
			daysign : daysign,
			tone : this.toneFromKin(kin),
			longcount : {
				baktun : baktun,
				katun : katun,
				tun : tun,
				uinal : uinal,
				day : day
			},
			longcountAll: baktun+'.'+katun+'.'+tun+'.'+uinal+'.'+day
		}
	},
	getConnections: function(daysign) {
		var connections = [];
		daysign = daysign*1;
		if(daysign > 20 || daysign < 1) {
			return [];
		} else {
			connections[0] = ((daysign+8) > 20)?(daysign+8-20):(daysign+8); //ты поддерживаешь
			connections[1] = ((daysign-8) < 1)?(20+(daysign-8)):(daysign-8); //тебя поддерживает
			connections[2] = ((daysign+6) > 20)?(daysign+6-20):(daysign+6); //ты контролируешь
			connections[3] = ((daysign-6) < 1)?(20+(daysign-6)):(daysign-6); //тебя контролирует
			connections[4] = ((daysign+10) > 20)?(daysign-10):(daysign+10); //страсть/испытание
			connections[5] = ((19-daysign) < 1)?(19-daysign+20):(19-daysign); //партнёр/друг
			connections[6] = 21-daysign; //тайная сила
			return connections;
		}
	},
	getFantomsLevel2: function(fantoms, daysign, trecena) {
		var connections = localStorage['fantomsLevel2'];
		if(daysign == trecena)
		{
			fantoms[fantoms.length] = daysign;
		} else {
			fantoms[fantoms.length] = daysign;
			fantoms[fantoms.length] = trecena;
		}
		var conns = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
		for(var i = 0;i < fantoms.length;i++)
		{
			var c = this.getConnections(fantoms[i]);
			for(var j = 0;j < c.length;j++)
				conns[c[j]]++;
		}
		var fns = [];
		for(var i = 0;i < fantoms.length;i++) conns[fantoms[i]] = 0;
		for(var i = 1;i < conns.length;i++)
			if(conns[i] >= connections)
				fns.push(i);
		return fns;
	},
	getFantoms: function(daysign, trecena) {
		var forClean = false;
		if(daysign == trecena && forClean == false)
		{
			return [];
		}
		var fns = [];
		var connections = 2;
		var fantoms = [];
		if(forClean || daysign != trecena)
		{
			fantoms.push(daysign);
			fantoms.push(trecena);
		}
		var conns = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
		for(var i = 0;i < fantoms.length;i++)
		{
			var c = this.getConnections(fantoms[i]);
			for(var j = 0;j < c.length;j++)
				conns[c[j]]++;
		}
		var fns = [];
		for(var i = 0;i < fantoms.length;i++) conns[fantoms[i]] = 0;
		for(var i = 1;i < conns.length;i++)
			if(conns[i] >= connections)
				fns.push(i);
		return fns;
	},
	getSignFromName: function(name) {
		var signs = [];
		function append_arr(arr, elem)
		{
			var finded = false;
			for(var i = 0;i < arr;i++)
			{
				if(arr[i]==elem)
				{
					finded = true;
					break;
				}
			}
			if(!finded)
			{
				arr[arr.length] = elem;
			}
			return arr;
		}
		for(var i = 0;i < name.length;i++)
		{
			for(var j = 1;j < this.daysignLettersUpper.length;j++)
			{
				if(this.daysignLettersUpper[j] == name[i] || this.daysignLettersLower[j] == name[i])
				{
					signs = append_arr(signs, j);
					break;
				}
			}
		}
		return signs;
	},
	compareDate: function(date1, date2) {
		if(date2.getFullYear() > date1.getFullYear() ||
		(date2.getFullYear() == date1.getFullYear() && date2.getMonth() > date1.getMonth()) ||
		(date2.getFullYear() == date1.getFullYear() && date2.getMonth() == date1.getMonth() && date2.getDate() > date1.getDate()))
		{
			return 1;
		} else if(date2.getFullYear() < date1.getFullYear() ||
		(date2.getFullYear() == date1.getFullYear() && date2.getMonth() < date1.getMonth()) ||
		(date2.getFullYear() == date1.getFullYear() && date2.getMonth() == date1.getMonth() && date2.getDate() < date1.getDate())) {
			return -1;
		} else {
			return 0;
		}
	},
	diffDate: function(date1, date2)
	{
		var t = date1;
		if(date2.getFullYear() > date1.getFullYear() ||
		(date2.getFullYear() == date1.getFullYear() && date2.getMonth() > date1.getMonth()) ||
		(date2.getFullYear() == date1.getFullYear() && date2.getMonth() == date1.getMonth() && date2.getDate() > date1.getDate()))
		{
			date1 = date2;
			date2 = t;
		}
		var y1 = date1.getFullYear();
		var y2 = date2.getFullYear();
		var m1 = date1.getMonth()+1;
		var m2 = date2.getMonth()+1;
		var d1 = date1.getDate();
		var d2 = date2.getDate();
		function getMonthLens(y)
		{
			var ml = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
			if(parseInt(y)%4==0)
				ml[2] = 29;
			return ml;
		}
		function dayNumber(y, m, d) {
			var monlens = getMonthLens(y);
			var number = 0;
			for(var i = 0;i < m;i++)
			{
				number+=monlens[i];
			}
			number+=d;
			return number;
		}
		var num1 = dayNumber(y1, m1, d1);
		var num2 = dayNumber(y2, m2, d2);
		if(y1 > y2)
		{
			if(y2%4==0)
				var days = 366-num2;
			else
				var days = 365-num2;
			for(var y = y2+1;y < y1;y++)
			{
				if(y%4==0)
					days+=366;
				else
					days+=365;
			}
			days+=num1;
			return days;
		}
		else if(y1 < y2)
		{
			if(y1%4==0)
				var days = 366-num1;
			else
				var days = 365-num1;
			for(var y = y1;y < y1;y++)
			{
				if(y%4==0)
					days+=366;
				else
					days+=365;
			}
			days+=num2;
			return days;
		}
		else if(num1 > num2)
		{
			return num1 - num2;
		}
		else if(num1 < num2)
		{
			return num2 - num1;
		}
		else
		{
			return 0;
		}
	},
	getTrecenaFromKin: function(kin)
	{
		return (((((kin%20)?(kin%20):20) - ((kin % 13) ? (kin % 13) : 13) + 1) < 1) ? (((kin%20)?(kin%20):20) - ((kin % 13) ? (kin % 13) : 13) + 21) : (((kin%20)?(kin%20):20) - ((kin % 13) ? (kin % 13) : 13) + 1));
	},
	getDaysignFromKin: function(kin)
	{
		return ((kin%20)?(kin%20):20);
	},
	nextDay: function(date) {
		var y = date.getFullYear()
		var dayLengths = [0, 31, y%4?28:29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
		var m = date.getMonth()+1;
		var d = date.getDate();
		if((d+1) > dayLengths[m])
		{
			if(m+1 > 12)
			{
				y++;
				m = 1;
				d = 1;
			} else {
				m++;
				d = 1;
			}
		} else {
			d++;
		}
		return (new Date(y + '-' + m + '-' + d));
	},
	backDay: function(date)
	{
		var y = date.getFullYear();
		var dayLengths = [0, 31, y%4?28:29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
		var m = date.getMonth()+1;
		var d = date.getDate();
		if((d-1) < 1)
		{
			if(m-1 < 1)
			{
				y--;
				m = 12;
				d = dayLengths[12];
			} else {
				m--;
				d = dayLengths[m];
			}
		} else {
			d--;
		}
		return (new Date(y + '-' + m + '-' + d));
	},
	calculateAllKinConnections: function() {

		//calculate all connections
		var kinlist = [];
		for(var i = 1; i <= 260; i++) {
			var kin = {
				kin: i,
				daysign: this.getDaysignFromKin(i),
				trecena: this.getTrecenaFromKin(i),
				connections: [],
			};
			kinlist[i] = kin;
		}
		kinlist = kinlist.map(kin => {
			for(var k = 1; k <= 260; k++) {
				var daysign = kinlist[k].daysign;
				var trecena = kinlist[k].trecena;
				var allCons = [this.getConnections(daysign), this.getConnections(trecena)];
				var signs = [kin.daysign, kin.trecena];
				var conTypes = [0, 0, 0, 0, 0, 0, 0, 0, 0];
				var isConnected = false;
				for(var i = 0;i < allCons.length;i++) {
					for(var j = 0;j < signs.length;j++) {
						for(var x = 0;x < allCons[i].length;x++){
							if(signs[j] == allCons[i][x]) {
								isConnected = true;
								conTypes[x]++;
							}
						}
					}
				}
				if(kinlist[k].daysign == kin.trecena || kinlist[k].trecena == kin.daysign)
				{
					conTypes[7]++;
					isConnected = true;
				}
				if(kinlist[k].daysign == kin.daysign || kinlist[k].trecena == kin.trecena)
				{
					conTypes[8]++;
					isConnected = true;
				}
				if(isConnected && kin.kin != k) {
					kin.connections.push({
						kin: k,
						connectionTypes: conTypes
					});
				} else if(kin.kin == k) {
					kin.connections.push({
						kin: k,
						connectionTypes: [0, 0, 0, 0, 0, 0, 0, 0, 1]
					});
				}
			}
			return kin;
		});
		return kinlist;
	}	
}